<template>
  <div class="menu-container">
      <el-menu
        class="custom-el-menu"
        mode="vertical"
        :show-timeout="200"
        :default-active="$route.path"
        background-color="transparent"
        text-color="#4E5969"
        active-text-color="#60CBBA"
        :router="true"
      >
        <sidebar-item :routes="routes"></sidebar-item>
      </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './topSidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'topSidebar',
      'routers'
    ]),
    activeMenuItem() {
      // 计算活动的菜单项路径，用于样式绑定
      return this.$route.matched.length ? this.$route.matched[0].path : '';
    },
    routes() {
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
   watch: {
    '$route': function() {
      this.updateActiveMenu();
    }
  },
  mounted() {
    this.updateActiveMenu();
  },
  methods: {
    updateActiveMenu() {
      const activeMenuItem = this.activeMenuItem;
      const items = document.querySelectorAll('.el-submenu__title');
      items.forEach((item) => {
        if (item.dataset.index === activeMenuItem) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
    }
  }
}
</script>

<style scoped>
.menu-container {
  width: 100%;
  height: 64px;
}

.custom-scroll-bar {
  border-radius: 10px; /* 设置圆角 */
}

.custom-el-menu {
  width: 100%;
  height: 64px;
  border-right: none;
  background: transparent;
}

.custom-el-menu >>> .el-menu-item.is-active,
.custom-el-menu >>> .el-submenu__title.is-active {
}

@media (max-width: 768px), (max-width: 960px) and (max-height: 540px) and (orientation: landscape) {
  .menu-container,
  .custom-el-menu {
    height: 104px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/topSidebar/index.vue